class SlideRecommendations extends HTMLElement {
  constructor() {
    super();

    this.slide = this;
    this.flkty = new Flickity(this.slide, {
      cellAlign: 'left',
      pageDots: true,
      prevNextButtons: false,
      imagesLoaded: true,
      wrapAround: true,
      groupCells: true
    });
  }
}

customElements.define('slide-recommendations', SlideRecommendations);